import { DropdownOption } from 'components/final-form/dropdownUtils';
import Select from 'components/final-form/Select';
import { FieldProps } from 'react-final-form';
import { DropdownItemProps } from 'semantic-ui-react';
import { IndexSignature } from 'utils/praxTypes';

export interface SelectFieldProps {
  name: string,
  component: any,
  validate?: any,
  search: any,
  clearable?: boolean,
  options: Array<DropdownItemProps>,
  allowAdditions?: boolean,
  remoteSearch?: boolean,
  customRemoteSearchMethod?: (search: string) => void,
  onNewAddition?: (addition: DropdownOption) => void
}

export const selectInput = (fields: FieldProps, selectMap: IndexSignature): SelectFieldProps => {
  return {
    name: fields.name,
    component: Select,
    validate: fields.validate,
    search: true,
    clearable: fields.clearable,
    options: selectMap[fields.name],
    allowAdditions: fields.allowAdditions,
    remoteSearch: fields.remoteSearch,
    customRemoteSearchMethod: fields.customRemoteSearchMethod,
    onNewAddition: fields.onNewAddition,
    ...fields
  }
};
